var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getBIC as getBicInternal } from "bic-from-iban";
export var getBic = function (iban) {
    var result = getBicInternal(iban);
    if (result) {
        return result;
    }
    return "Unknown bic";
};
/**
 * Cache key for one contact's bank account list. A contact and the account it
 * belongs to resolve to the same list, but only the API call can tell which
 * contact an account maps to, so a caller that has the account id keys on that
 * instead. Both keys are namespaced so they can never collide.
 */
export var getContactBankAccountsKey = function (_a) {
    var contactId = _a.contactId, accountId = _a.accountId;
    if (contactId != null) {
        return "contact-".concat(contactId);
    }
    if (accountId != null) {
        return "account-".concat(accountId);
    }
};
/**
 * The V2 API entity renamed the third-party flag to `isThirdPartyIban`, while
 * the column, the V1 API and every consumer of `IIban` - web and mobile - spell
 * it `isThirdpartyIban`. Translating on the edge keeps that single spelling in
 * the frontend rather than pushing a second one through every screen.
 */
export var mapApiBankAccount = function (bankAccount) {
    var isThirdPartyIban = bankAccount.isThirdPartyIban, rest = __rest(bankAccount, ["isThirdPartyIban"]);
    return __assign(__assign({}, rest), { isThirdpartyIban: isThirdPartyIban });
};
export var mapCreateBankAccountPayload = function (payload) {
    var isThirdpartyIban = payload.isThirdpartyIban, rest = __rest(payload, ["isThirdpartyIban"]);
    return __assign(__assign({}, rest), { isThirdPartyIban: isThirdpartyIban });
};
